export class StorageUtils {
    public static setItem(key: string, value?: any): void {
        localStorage.setItem(key, value);
    }

    public static getItem(key: string): string {
        return localStorage.getItem(key);
    }

    public static removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    public static setItemWithExpire(key: string, value?: any, expiretime?: number): void {
        const record = {value: value, timestamp: new Date().getTime() + expiretime * 1000};
        localStorage.setItem(key, JSON.stringify(record));
    }

    public static getItemWithExpire(key: string): string {
        const record = JSON.parse(localStorage.getItem(key));
        if (!record) {
            return record;
        }

        if (new Date().getTime() > record.timestamp) {
            localStorage.removeItem(key);
            return null;
        }
        return record.value;
    }
}









// WEBPACK FOOTER //
// ./src/app/shared/utils/src/storage.utils.ts